<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br>
                    <div>
                        <p class="texto2">Lo sentimos :(</p>
                        <p class="texto1">
                            Luego de realizar algunas validaciones,<br>
                            lamentamos decirte que no podemos<br>
                            ofrecerte el Seguro de Arriendo Digital de<br>
                            SURA, pues no cumples con nuestras<br>
                            políticas internas.
                        </p>
                    </div>
                    <br>
                    <img src="./assets/img/callCenter.png" />
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/callCenter.png" />
                    <br>
                    <div>
                        <p class="texto2">Lo sentimos :(</p>
                        <p class="texto1">
                            Luego de realizar algunas validaciones, lamentamos decirte que no podemos ofrecerte el
                            Seguro de Arriendo Digital de SURA, pues no cumples con nuestras políticas internas.
                        </p>
                    </div>
                </div>
                <br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="volverInicio()">
                        Volver al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>